export default {
  ROUTER_NAVIGATE: 'ROUTER_NAVIGATE',
  ROUTER_MODAL_NAVIGATE: 'ROUTER_MODAL_NAVIGATE',

  HOME_STORE_FETCH_HOT_NOW: 'HOME_STORE_FETCH_HOT_NOW',
  HOME_STORE_FETCH_HOT_NOW_COMPLETED: 'HOME_STORE_FETCH_HOT_NOW_COMPLETED',
  HOME_STORE_FETCH_TO_COMPLETE: 'HOME_STORE_FETCH_TO_COMPLETE',
  HOME_STORE_FETCH_TO_COMPLETE_COMPLETED: 'HOME_STORE_FETCH_TO_COMPLETE_COMPLETED',
  HOME_STORE_FETCH_NEVER_SEEN: 'HOME_STORE_FETCH_NEVER_SEEN',
  HOME_STORE_FETCH_NEVER_SEEN_COMPLETED: 'HOME_STORE_FETCH_NEVER_SEEN_COMPLETED',

  HOME_STORE_SET_SELECTED_TERMS: 'HOME_STORE_SET_SELECTED_TERMS',

  GLOSSARY_GET_ALL_TERMS: 'GLOSSARY_GET_ALL_TERMS',
  GLOSSARY_GET_ALL_TERMS_COMPLETED: 'GLOSSARY_GET_ALL_TERMS_COMPLETED',

  GLOSSARY_GET_TERM: 'GLOSSARY_GET_TERM',
  GLOSSARY_GET_TERM_COMPLETED: 'GLOSSARY_GET_TERM_COMPLETED',

  COLLECTIONS_FETCH: 'COLLECTIONS_FETCH',
  COLLECTIONS_FETCH_COMPLETE: 'COLLECTIONS_FETCH_COMPLETE',

  COLLECTION_FETCH: 'COLLECTION_FETCH',
  COLLECTION_FETCH_COMPLETE: 'COLLECTION_FETCH_COMPLETE',

  COLLECTION_ARCHIVED_FETCH: 'COLLECTION_ARCHIVED_FETCH',
  COLLECTION_ARCHIVED_FETCH_COMPLETE: 'COLLECTION_ARCHIVED_FETCH_COMPLETE',

  COLLECTION_STORE_INTRO_CHAPTER_ENTER: 'COLLECTION_STORE_INTRO_CHAPTER_ENTER',

  CATEGORY_STORE_FETCH: 'TIMELESS_STORE_FETCH',
  CATEGORY_STORE_FETCH_COMPLETE: 'TIMELESS_STORE_FETCH_COMPLETE',

  CATEGORY_BY_ID_STORE_FETCH: 'TIMELESS_BY_ID_STORE_FETCH',
  CATEGORY_BY_ID_STORE_FETCH_COMPLETE: 'TIMELESS_BY_ID_STORE_FETCH_COMPLETE',

  CHAPTER_STORE_FETCH_FOR_THEME: 'CHAPTER_STORE_FETCH_FOR_THEME',
  CHAPTER_STORE_FETCH_FOR_COLLECTION: 'CHAPTER_STORE_FETCH_FOR_COLLECTION',
  CHAPTER_STORE_FETCH_COMPLETE: 'CHAPTER_STORE_FETCH_COMPLETE',

  THEME_STORE_ALL: 'THEME_STORE_ALL',
  THEME_STORE_ALL_COMPLETE: 'THEME_STORE_ALL_COMPLETE',
  THEME_STORE_FIND: 'THEME_STORE_FIND',
  THEME_STORE_FIND_COMPLETE: 'THEME_STORE_FIND_COMPLETE',
  THEME_STORE_COMPLETE: 'THEME_STORE_COMPLETE',
  THEME_STORE_CHAPTER_ENTER: 'THEME_STORE_CHAPTER_ENTER',

  TIMELESS_THEME_STORE_FIND: 'TIMELESS_THEME_STORE_FIND',
  TIMELESS_THEME_STORE_FIND_COMPLETE: 'TIMELESS_THEME_STORE_FIND_COMPLETE',
  TIMELESS_THEME_STORE_MARK_AS_COMPLETED: 'TIMELESS_THEME_STORE_MARK_AS_COMPLETED',

  CHAPTER_GLOSSARY_STORE_FETCH_COMPLETE: 'CHAPTER_GLOSSARY_STORE_FETCH_COMPLETE',

  GET_ALL_TAGS: 'GET_ALL_TAGS',
  GET_ALL_TAGS_COMPLETED: 'GET_ALL_TAGS_COMPLETED',

  MANUALS_FETCH: 'MANUALS_FETCH',
  MANUALS_FETCH_COMPLETE: 'MANUALS_FETCH_COMPLETE',
  MANUAL_SAVE_ACTIVITY_FETCH: 'MANUAL_SAVE_ACTIVITY_FETCH',

  NAVIGATION_GET: 'NAVIGATION_GET',
  NAVIGATION_GET_COMPLETE: 'NAVIGATION_GET_COMPLETE',

  LOGIN_COMPLETED: 'LOGIN_COMPLETED',
  CONFIRM_AUTHENTICATION: 'CONFIRM_AUTHENTICATION',

  JWT_LOGIN_COMPLETED: 'JWT_LOGIN_COMPLETED',

  LOGOUT: 'LOGOUT',

  ACTIVITY_SAVED: 'ACTIVITY_SAVED',

  LANGUAGE_STORE_FETCH: 'LANGUAGE_STORE_FETCH',
  LANGUAGE_STORE_FETCH_COMPLETED: 'LANGUAGE_STORE_FETCH_COMPLETED',

  SEARCH_STORE_SEARCH: 'SEARCH_STORE_SEARCH',
  SEARCH_STORE_SEARCH_COMPLETED: 'SEARCH_STORE_SEARCH_COMPLETED',

  USER_STORE_FETCH: 'USER_STORE_FETCH',
  USER_STORE_FETCH_COMPLETED: 'USER_STORE_FETCH_COMPLETED',
  USER_STORE_UPDATE_LANGUAGE: 'USER_STORE_UPDATE_LANGUAGE',
  USER_STORE_UPDATE_LANGUAGE_COMPLETED: 'USER_STORE_UPDATE_LANGUAGE_COMPLETED',

  GET_NEWS_MODAL_VISIBILITY: 'GET_NEWS_MODAL_VISIBILITY',

  MODAL_FULLSCREEN_MODAL_HELP: 'MODAL_FULLSCREEN_MODAL_HELP',
  MODAL_FULLSCREEN_REPORT_PROBLEM_USER: 'MODAL_FULLSCREEN_REPORT_PROBLEM_USER',
  MODAL_FULLSCREEN_REPORT_PROBLEM_STORE: 'MODAL_FULLSCREEN_REPORT_PROBLEM_STORE',
  MODAL_FULLSCREEN_USER: 'MODAL_FULLSCREEN_USER',
  MODAL_FULLSCREEN_GLOSSARY: 'MODAL_FULLSCREEN_GLOSSARY',
  MODAL_FULLSCREEN_CLOSE: 'MODAL_FULLSCREEN_CLOSE',
  MODAL_FULLSCREEN_CLOSED: 'MODAL_FULLSCREEN_CLOSED',
  MODAL_FULLSCREEN_CLOSED_CLEAR_ROUTE_URI: 'MODAL_FULLSCREEN_CLOSED_CLEAR_ROUTE_URI',

  ERROR_HTTP_401: 'ERROR_HTTP_401',
  ERROR_HTTP_404: 'ERROR_HTTP_404',
  ERROR_HTTP_403: 'ERROR_HTTP_403',
  ERROR_HTTP_GENERIC: 'ERROR_HTTP_GENERIC',

  PRODUCT_FOCUSES_FETCH: 'PRODUCT_FOCUSES_FETCH',
  PRODUCT_FOCUSES_FETCH_COMPLETED: 'PRODUCT_FOCUSES_FETCH_COMPLETED',

  PRODUCT_FOCUS_FETCH_BY_ID: 'PRODUCT_FOCUS_FETCH_BY_ID',
  PRODUCT_FOCUS_FETCH_BY_ID_COMPLETED: 'PRODUCT_FOCUS_FETCH_BY_ID_COMPLETED',

  PRODUCT_FOCUS_GROUP_CONTENT_VIEWED: 'PRODUCT_FOCUS_GROUP_CONTENT_VIEWED',
  PRODUCT_FOCUS_GROUP_CONTENT_VIEWED_COMPLETED: 'PRODUCT_FOCUS_GROUP_CONTENT_VIEWED_COMPLETED',

  PRODUCT_FOCUS_VIEWED: 'PRODUCT_FOCUS_VIEWED',
  PRODUCT_FOCUS_VIEWED_COMPLETED: 'PRODUCT_FOCUS_VIEWED_COMPLETED',

  MOBILE_MODAL_SEARCH: 'MOBILE_MODAL_SEARCH',

  GLOSSARY_TOGGLE_FILTER_ICON: 'GLOSSARY_TOGGLE_FILTER_ICON',
  GLOSSARY_UPDATE_FILTER: 'GLOSSARY_UPDATE_FILTER',
  GLOSSARY_UPDATE_LETTER_RANGE: 'GLOSSARY_UPDATE_LETTER_RANGE',
  GLOSSARY_VIEW_TERM: 'GLOSSARY_VIEW_TERM',

  MOBILE_MODAL_NEWS: 'MOBILE_MODAL_NEWS',
}
